"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChildAge = ChildAge;
exports.CollegeAge = CollegeAge;
exports.CollegeInflationRate = CollegeInflationRate;
exports.CollegeSavings = CollegeSavings;
exports.CollegeTerm = CollegeTerm;
exports.FundPercent = FundPercent;
exports.RateReturn = RateReturn;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _formikMiddleware = _interopRequireDefault(require("../../middleware/formikMiddleware"));
var _CollegeSavingsWizardCalc = require("./CollegeSavingsWizardCalc.config");
var _DropdownSelect = _interopRequireDefault(require("react-blueprint-library/build/cjs/Dropdown/DropdownSelect"));
var _TextInputForForm = require("../Wizard/TextInputForForm");
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
var _PopoverAndOverlay = require("../Wizard/PopoverAndOverlay");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ChildAge(_ref) {
  var _errors$children, _touched$children, _values$children, _errors$children2, _touched$children2, _errors$children3;
  var {
    errors,
    touched,
    values,
    i
  } = _ref;
  var fieldName = 'childAge';
  var label = 'Age';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '3';
  var placeholder = '00';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: _CollegeSavingsWizardCalc.idPrefix + fieldName + i
  }, label, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, " ")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat((errors === null || errors === void 0 || (_errors$children = errors.children) === null || _errors$children === void 0 || (_errors$children = _errors$children[i]) === null || _errors$children === void 0 ? void 0 : _errors$children[fieldName]) && (touched === null || touched === void 0 || (_touched$children = touched.children) === null || _touched$children === void 0 || (_touched$children = _touched$children[i]) === null || _touched$children === void 0 ? void 0 : _touched$children[fieldName]) && 'is-invalid')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    id: _CollegeSavingsWizardCalc.idPrefix + fieldName + i,
    "aria-label": fieldName + i,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    name: "children[".concat(i, "].").concat(fieldName),
    value: values === null || values === void 0 || (_values$children = values.children) === null || _values$children === void 0 || (_values$children = _values$children[i]) === null || _values$children === void 0 ? void 0 : _values$children[fieldName],
    placeholder: placeholder,
    onChange: (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true
    }).handleChange(),
    onBlur: (0, _formikMiddleware.default)().tealium(_CollegeSavingsWizardCalc.calcName, fieldName).handleBlur()
  })), errors !== null && errors !== void 0 && (_errors$children2 = errors.children) !== null && _errors$children2 !== void 0 && (_errors$children2 = _errors$children2[i]) !== null && _errors$children2 !== void 0 && _errors$children2[fieldName] && touched !== null && touched !== void 0 && (_touched$children2 = touched.children) !== null && _touched$children2 !== void 0 && (_touched$children2 = _touched$children2[i]) !== null && _touched$children2 !== void 0 && _touched$children2[fieldName] ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl.Feedback, {
    type: "invalid",
    className: "custom-feedback"
  }, errors === null || errors === void 0 || (_errors$children3 = errors.children) === null || _errors$children3 === void 0 || (_errors$children3 = _errors$children3[i]) === null || _errors$children3 === void 0 ? void 0 : _errors$children3[fieldName]) : ''));
}
function CollegeAge(_ref2) {
  var _errors$children4, _touched$children3, _touched$children4, _values$children2, _errors$children5;
  var {
    errors,
    touched,
    values,
    i
  } = _ref2;
  var fieldName = 'collegeAge';
  var label = 'Entry Age';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '3';
  var placeholder = '00';

  // custom invalid function for this component, once either the ChildAge or CollegeAge is touched

  var isInvalid = (errors === null || errors === void 0 || (_errors$children4 = errors.children) === null || _errors$children4 === void 0 || (_errors$children4 = _errors$children4[i]) === null || _errors$children4 === void 0 ? void 0 : _errors$children4[fieldName]) && ((touched === null || touched === void 0 || (_touched$children3 = touched.children) === null || _touched$children3 === void 0 || (_touched$children3 = _touched$children3[i]) === null || _touched$children3 === void 0 ? void 0 : _touched$children3[fieldName]) || (touched === null || touched === void 0 || (_touched$children4 = touched.children) === null || _touched$children4 === void 0 || (_touched$children4 = _touched$children4[i]) === null || _touched$children4 === void 0 ? void 0 : _touched$children4.childAge));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: _CollegeSavingsWizardCalc.idPrefix + fieldName + i
  }, label, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, " ")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    id: _CollegeSavingsWizardCalc.idPrefix + fieldName + i,
    "aria-label": fieldName + i,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    name: "children[".concat(i, "].").concat(fieldName),
    value: values === null || values === void 0 || (_values$children2 = values.children) === null || _values$children2 === void 0 || (_values$children2 = _values$children2[i]) === null || _values$children2 === void 0 ? void 0 : _values$children2[fieldName],
    placeholder: placeholder,
    onChange: (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true
    }).handleChange(),
    onBlur: (0, _formikMiddleware.default)().tealium(_CollegeSavingsWizardCalc.calcName, fieldName).handleBlur()
  })), isInvalid ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl.Feedback, {
    type: "invalid",
    className: "custom-feedback"
  }, errors === null || errors === void 0 || (_errors$children5 = errors.children) === null || _errors$children5 === void 0 || (_errors$children5 = _errors$children5[i]) === null || _errors$children5 === void 0 ? void 0 : _errors$children5[fieldName]) : ''));
}
function FundPercent(_ref3) {
  var _errors$children6, _touched$children5, _values$children3, _errors$children7, _touched$children6, _errors$children8;
  var {
    errors,
    touched,
    values,
    i
  } = _ref3;
  var fieldName = 'fundPercent';
  var label = 'I plan to fund';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '5';
  var placeholder = '00';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: _CollegeSavingsWizardCalc.idPrefix + fieldName + i
  }, label, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, " ")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat((errors === null || errors === void 0 || (_errors$children6 = errors.children) === null || _errors$children6 === void 0 || (_errors$children6 = _errors$children6[i]) === null || _errors$children6 === void 0 ? void 0 : _errors$children6[fieldName]) && (touched === null || touched === void 0 || (_touched$children5 = touched.children) === null || _touched$children5 === void 0 || (_touched$children5 = _touched$children5[i]) === null || _touched$children5 === void 0 ? void 0 : _touched$children5[fieldName]) && 'is-invalid')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    id: _CollegeSavingsWizardCalc.idPrefix + fieldName + i,
    "aria-label": fieldName + i,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    name: "children[".concat(i, "].").concat(fieldName),
    value: values === null || values === void 0 || (_values$children3 = values.children) === null || _values$children3 === void 0 || (_values$children3 = _values$children3[i]) === null || _values$children3 === void 0 ? void 0 : _values$children3[fieldName],
    placeholder: placeholder,
    onChange: (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: false,
      currencyInput: false,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange(),
    onBlur: (0, _formikMiddleware.default)().tealium(_CollegeSavingsWizardCalc.calcName, fieldName).handleBlur()
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "input-group-append"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "input-group-text"
  }, '%'))), errors !== null && errors !== void 0 && (_errors$children7 = errors.children) !== null && _errors$children7 !== void 0 && (_errors$children7 = _errors$children7[i]) !== null && _errors$children7 !== void 0 && _errors$children7[fieldName] && touched !== null && touched !== void 0 && (_touched$children6 = touched.children) !== null && _touched$children6 !== void 0 && (_touched$children6 = _touched$children6[i]) !== null && _touched$children6 !== void 0 && _touched$children6[fieldName] ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl.Feedback, {
    type: "invalid",
    className: "custom-feedback"
  }, errors === null || errors === void 0 || (_errors$children8 = errors.children) === null || _errors$children8 === void 0 || (_errors$children8 = _errors$children8[i]) === null || _errors$children8 === void 0 ? void 0 : _errors$children8[fieldName]) : ''));
}
function CollegeTerm(_ref4) {
  var _values$children4, _values$children5;
  var {
    setFieldValue,
    i,
    values
  } = _ref4;
  var label = 'College Type ';
  var fieldName = 'collegeTerm';
  var placeholderText = 'Select One';
  /* istanbul ignore next */
  var handleDropdownOnSelect = (value, field, setFieldValue) => {
    setFieldValue("children[".concat(i, "].[").concat(fieldName, "]"), value);
    if (field && typeof utag === 'object' && utag.link && value) {
      utag.link({
        event_category: _CollegeSavingsWizardCalc.calcName,
        event_action: 'field_input',
        event_label: field,
        event_property: value
      });
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: fieldName
  }, label, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null), /*#__PURE__*/_react.default.createElement(_PopoverAndOverlay.PopoverAndOverlay, {
    fieldName: fieldName,
    text: (0, _htmlReactParser.default)(_CollegeSavingsWizardCalc.popoverConfig.collegeTerm)
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, null, /*#__PURE__*/_react.default.createElement(_DropdownSelect.default, {
    data: _CollegeSavingsWizardCalc.dropdownOptions.collegeTermArray,
    onSelect: value => {
      return handleDropdownOnSelect(value, fieldName, setFieldValue);
    },
    defaultLabel: (values === null || values === void 0 || (_values$children4 = values.children) === null || _values$children4 === void 0 || (_values$children4 = _values$children4[i]) === null || _values$children4 === void 0 ? void 0 : _values$children4[fieldName]) != '' ? values === null || values === void 0 || (_values$children5 = values.children) === null || _values$children5 === void 0 || (_values$children5 = _values$children5[i]) === null || _values$children5 === void 0 ? void 0 : _values$children5[fieldName] : placeholderText || 'Select One',
    toggleId: fieldName,
    toggleName: fieldName
  })));
}
function CollegeInflationRate(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'collegeInflation';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: false,
      currencyInput: false,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_CollegeSavingsWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "College Inflation Rate",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    id: _CollegeSavingsWizardCalc.idPrefix + fieldName,
    popoverText: _CollegeSavingsWizardCalc.popoverConfig.inflationRate,
    inputMode: "numeric",
    maxLength: "5",
    placeholder: "00.00",
    prepend: false,
    append: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function RateReturn(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'rateReturn';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: false,
      currencyInput: false,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_CollegeSavingsWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Rate of Return on Savings",
    id: _CollegeSavingsWizardCalc.idPrefix + fieldName,
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    popoverText: _CollegeSavingsWizardCalc.popoverConfig.rateReturn,
    inputMode: "numeric",
    maxLength: "5",
    placeholder: "00.00",
    prepend: false,
    append: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function CollegeSavings(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'savings';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_CollegeSavingsWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Current College Savings Balance",
    id: _CollegeSavingsWizardCalc.idPrefix + fieldName,
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "0",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}